import type { HTTPMessage } from '@carboncopyco/types';
import { useMemo } from 'react';
import { TransactionContent } from './TransactionContent';

export interface HeadersContentProps {
  message: HTTPMessage;
  onChange?: (value: string) => void;
}
export const HeadersContent = ({ message, onChange }: HeadersContentProps) => {
  const headers = useMemo(
    () => JSON.stringify(message.headers),
    [message.headers]
  );

  return (
    <TransactionContent
      value={headers}
      language="json"
      onChange={onChange}
    />
  );
};
